import { render } from "./invite-customers-via-link.vue?vue&type=template&id=ec6fb532"
import script from "./invite-customers-via-link.vue?vue&type=script&lang=js"
export * from "./invite-customers-via-link.vue?vue&type=script&lang=js"
script.render = render

export default script